export default __webpack_public_path__ + "static/easy-dai-f643a83bc08744ff095a8e34fa4e21b1.png";